import { useTranslation, withTranslation } from "next-i18next";
import { useMediaQuery, useTheme } from "@mui/material";
import type { IPropsPageTentangKami } from "../../pages/tentang-kami";
import Desktop from "./lib/Desktop";
import AboutPartial from "@containers/Profile/lib/MobilePwa/Partials/About";
import Header from "@layouts/Main/lib/Header";
import HeadAndFilterMobile from "@fragments/HeadAndFilter/Mobile";

const About: React.FC<IPropsPageTentangKami> = ({ dataNavbar }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation("common");

  if (isMobile) {
    return (
      <>
        <HeadAndFilterMobile goBack title={t("about.title")} />
        <AboutPartial />
      </>
    );
  }

  return (
    <>
      <Header
        setExpand={function (): void {
          throw new Error("Function not implemented.");
        }}
      />
      <Desktop dataNavbar={dataNavbar} />
    </>
  );
};

export default withTranslation("common")(About);
